import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconsPath = 'assets/icons/svg';
  private iconCache: { [key: string]: SafeHtml } = {};
  constructor(
    private sanitizer: DomSanitizer,
    private httpClient: HttpClient
  ) {}

  getSvgIcon(iconType: string, iconName: string): Observable<SafeHtml> {
    const cacheKey = `${iconType}/${iconName}`;
    if (this.iconCache[cacheKey]) {
      return of(this.iconCache[cacheKey]);
    }

    return this.httpClient.get(`${this.iconsPath}/${iconType}/${iconName}.svg`, { responseType: 'text' }).pipe(
      map(svg => {
        const sanitizedSvg = this.sanitizeSvg(svg);
        const safeHtml = this.sanitizer.bypassSecurityTrustHtml(sanitizedSvg) || '';
        this.iconCache[cacheKey] = safeHtml;

        return safeHtml;
      }),
      catchError(() => of('')) // Handle errors gracefully
    );
  }

  private sanitizeSvg(svg: string): string {
    return svg.replace(/(width="24"|height="24")/g, '');
  }
}
